import { useQuery, useQueryClient } from "@tanstack/react-query";
import { documentsKeys } from "./documents-keys";
import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { qDocument, QDocument } from "../../odata/appu4dm/QAppU4DM";
import { odataFetch } from "../../lib/odata-fetch";
import { Document } from "../../odata/document/DocumentModel";
import { getDocumentsQueryOptions } from "./use-documents";
import { useWorkOrderOperationId } from "../work-order/use-work-order-operation-id";

export function useDocument(id?: string) {
  const queryClient = useQueryClient();
  const { workOrderOperationId } = useWorkOrderOperationId();
  const wooId = workOrderOperationId?.WorkOrderOperation_Id;

  const { data, ...query } = useQuery({
    queryKey: documentsKeys.getDocument(id!),
    queryFn: async ({ meta }) => {
      const data = await fetchDocument(id!, meta!.token!);
      const document = data?.value?.[0];
      const documentsQueryOptions = getDocumentsQueryOptions(wooId);

      const documents = await queryClient.fetchQuery(documentsQueryOptions);

      if (!documents?.value.some((x) => x.Document === document?.Id)) {
        queryClient.setQueryData(documentsQueryOptions.queryKey, (data) => {
          return {
            ...data,
            value: [
              ...(data?.value ?? []),
              {
                Category: "Material", // Harcode to be in "Parts" category
                ContainerTypeId: null,
                Document: document?.Id ?? null,
                ExecutionGroupPhase: null,
                FileId: document?.LocalFile_Id_Id ?? null,
                FileName: document?.FileName ?? null,
                IconId: document?.Icon_Id_Id ?? null,
                Id: document?.Id ?? "",
                MIMEType: document?.MIMEType ?? null,
                NId: document?.NId ?? null,
                PLMXPackageId: null,
                SerialNumber: null,
                Type: null,
                UId: null,
                WorkOrderOperation: null,
                WorkOrderStep: null,
              },
            ],
          };
        });
      }

      return data;
    },
    enabled: ({ meta }) => !!meta?.token && !!id,
    select: (data) => data?.value?.[0],
  });

  return {
    document: data,
    ...query,
  };
}

async function fetchDocument(id: string, token: string) {
  const builder = createQueryBuilderV4("Document", new QDocument()).filter(
    qDocument.Id.eq(id)
  );

  return odataFetch<Document>({ builder, token, service: "Document" });
}
